export const url = "https://digilab-api.tech";
